<script lang="ts">
  import type { Snippet } from "svelte"
  import Icon from "@kontextwerk/web-sdk/ui/primitives/Icon.svelte"
  import { mdiChevronDown } from "@mdi/js"

  let {
    title,
    open = $bindable(false),
    metadata,
    children,
    onOpenChange,
  }: {
    title: string
    open?: boolean
    metadata?: Snippet
    children: Snippet
    onOpenChange?: (open: boolean) => void
  } = $props()
  const contentId = $props.id()
</script>

<details
  class="learning-disclosure"
  bind:open
  ontoggle={(event) => onOpenChange?.(event.currentTarget.open)}
>
  <summary aria-expanded={open} aria-controls={contentId}>
    <span class="disclosure-title">{title}</span>
    {#if metadata}<span class="metadata">{@render metadata()}</span>{/if}
    <span class="chevron" aria-hidden="true"><Icon path={mdiChevronDown} size="20px" /></span>
  </summary>
  <div class="disclosure-content" id={contentId}>{@render children()}</div>
</details>

<style>
  .learning-disclosure {
    min-width: 0;
    color: inherit;
    border-bottom: 1px solid var(--learning-divider, #d8dfe2);
  }
  summary {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    min-height: 44px;
    box-sizing: border-box;
    padding: 10px 8px;
    list-style: none;
    color: inherit;
    background: transparent;
    font-size: 17px;
    font-weight: 600;
    line-height: 1.45;
    cursor: pointer;
  }
  summary::-webkit-details-marker {
    display: none;
  }
  summary::marker {
    content: "";
  }
  summary:hover {
    background: var(--learning-hover, #f2f4f5);
  }
  summary:focus-visible {
    outline: 2px solid var(--learning-focus, #176288);
    outline-offset: 2px;
  }
  .disclosure-title {
    min-width: 0;
    flex: 1;
    overflow-wrap: anywhere;
  }
  .metadata {
    font-size: 15px;
    font-weight: 400;
    white-space: nowrap;
  }
  .chevron {
    display: flex;
    flex: 0 0 20px;
    transition: transform 180ms ease;
  }
  details[open] > summary .chevron {
    transform: rotate(180deg);
  }
  .disclosure-content {
    min-width: 0;
    padding: 12px 8px 16px;
  }
  @media (prefers-reduced-motion: reduce) {
    .chevron {
      transition: none;
    }
  }
</style>
